const i = i => i.isMultiline,
  l = i => !i.isMultiline,
  t = (i, l) => !i.isMultiline,
  e = (i, l) => i.isMultiline;
export { l as isInputField, t as isInputRef, i as isTextAreaField, e as isTextAreaRef };